import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=6018b674&scoped=true&"
import script from "./NotificationPage.vue?vue&type=script&lang=ts&"
export * from "./NotificationPage.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=6018b674&prod&lang=scss&"
import style1 from "./NotificationPage.vue?vue&type=style&index=1&id=6018b674&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6018b674",
  null
  
)

export default component.exports